import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-contact-us-button',
  templateUrl: './contact-us-button.component.html',
  styleUrls: ['./contact-us-button.component.scss']
})
export class ContactUsButtonComponent implements OnInit {
  contactMethod: string;
  link:string;
  constructor() {
  }

  ngOnInit(): void {
    const now = moment();
    const hour = now.get('hour');

    if (hour > 8 && hour <= 18) {
      this.contactMethod = 'wa';
      this.link = 'https://wa.me/972506880102';
    } else {
      this.contactMethod = 'mail';
      this.link = 'mailto:elad@slickchain.com';
    }
  }

}
